import React, {useEffect, useState,useContext} from 'react'
import Header from "../components/header/Header";
import "../components/css/film.css"
import doublearrow from '../images/double-arrow.png'
import close from '../images/close.png'
import searchIcon from '../images/search-26233.png'
import { keyContext } from "../components/KeyContext";
import GrundData from '../components/GrundData';
import xmlToJSON from '../components/xml-to-js'
import Synopsis from '../components/Synopsis';
import whiteArrow from '../images/white-arrow.svg'
import FilmOrgs from '../components/FilmOrgs';
import Visuals from '../components/Visuals';
import Banners from '../components/Banners';
import Trailer from '../components/Trailer';

function Film() {
    const key = sessionStorage.getItem("key");
    let orgNo = sessionStorage.getItem('filmOrg')
    let default_filmID = sessionStorage.getItem('default-filmID')
   
    // const [orgChanged, setOrgChanged] = useState('');
    let orgSelect = orgNo && orgNo.split(" ")[orgNo.split(" ").length - 1]
    const [distibutors, setDistibutors] = useState([]);
    const [bkdMovies, setBkdMovies] = useState([]);
    const [searchPrecise, setSearchPrecise] = useState(false);
    const [preciseFilm, setPreciseFilm] = useState();
    const [selectedMovieData, setSelectedMovieData, ] = useState([]);
    const [showFilms, setShowFilms]   = useState(false);
    const [allMovies, setallMovies] = useState([]);
    const [error, setError] = useState(false);
    const [filmSearch, setFilmSearch ]  = useState([])
    const [movieClicked, setMovieClicked] = useState(false);
    const [clkdMoviePoster, setClkdMoviePoster] = useState();
    const [arrtypes, setArrtypes] = useState([]);
    const orgID = sessionStorage.getItem('orgID')
    const [selectedBtnTitle, setSelectedBtnTitle] = useState('');
    const [showBtn, setShowBtn] = useState(false);
    let theme = localStorage.getItem("theme");

    const { titleChanged,filmBioChanged, setFilmbiochanged,selectedFilmId, setSelectedFilmId, visualDivHeight , clkdMovieName, setClkdMovieName} = useContext(keyContext);
    //console.log(filmSearch, 'film searcg')
      const data = Object.values(filmSearch && filmSearch.length ?  filmSearch : [] )
      // console.log(data, 'data')
// console.log(visualDivHeight, 'visual height')
  useEffect(() => {
    document.title = "Film edit - ebillet_admin";
  }, []);

  function handlePreciseSearch () {
    setSearchPrecise((current) => !current)
  }
// console.log(searchPrecise, 'search precise')
  // console.log(titleChanged, 'title changed')
    // all movies api call
    useEffect(() => {
      const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_getprogram?Key=${key}&strOrganizers=${orgSelect}`;
      if(key) {
        fetch(endpoint, {
          method: "GET",
          headers: {
            ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
          },
        })
        .then((res) => res.json())
        .then((result) => {
          //console.log(result)
           if(result.Message) {
          q.length &&  setError(true)
           }
           else {
            setallMovies(result.Movies)
            setArrtypes(result.ArrTypes)
          }
        })
      }
    }, [orgSelect,key]);



    function handleShowFilm () {
        setShowFilms( current => !current)
  }

  /**---------search functions----------- */
  const [q, setQ] = useState("");
  const [searchParam] = useState(["name"]);
  const [filterParam, setFilterParam] = useState(["name"]);
// console.log(filmSearch, 'film search')
function search(items) {
  return items.filter((item) => {
   
      if (filterParam == "name") {
          return searchParam.some((newItem) => {
              return (
                 item[newItem]
                      .toString()
                      .toLowerCase()
                      .indexOf(q.toLowerCase()) > -1
              );
          });
      }
  });
 
}
//------------fetching distibutor and BKD data--------
useEffect(() => {
  fetch('https://biograf.ebillet.dk/systemnative/export.asmx/LoadDistributorsAndBKDMovies', {
    method:"GET"
  })
  .then(res => res.text())
  .then((result) => {
    const json = xmlToJSON.parseString(result)
    const data = json.itemList
    // console.log(data, 'distri data')
    setDistibutors(data.preferences.distributors.distributor)
    setBkdMovies(data.preferences.bKDMovies.bKDMovie)
  })
}, []);

// -------------- when biograf list has only one bio, setting default-filmID----------
 useEffect(() => {
    const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_getorganizers?Key=${key}`;
    if (key) {
      fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      })
        .then((res) => res.json())
        .then((result) => {
          // console.log(result)
          if (result.result === 0) {
            //navigate("/");
          }
          // setFilm(result);
          // if there is only bio then it will be selected by default
          if (result.length === 1) {
            sessionStorage.setItem("default-filmID", result[0].No);
          }
        });
    }
  }, [key]);

//------ api call for movie search ------------

    // search movie api call
    useEffect(() => {
      // search precise no % 
      const endpoint1 = `https://biograf.ebillet.dk/systemnative/export.asmx/SearchMoviesWithAddings?nOrgNo=${default_filmID?default_filmID:orgSelect}&SearchString=${'%25'+q+'%25'}`
       const endpoint =`https://biograf.ebillet.dk/systemnative/export.asmx/SearchMoviesWithAddings?nOrgNo=${default_filmID?default_filmID:orgSelect}&SearchString=${q}`
      if(key ) {
        fetch(searchPrecise === true ? endpoint : endpoint1, {
          method: "GET",
          headers: {
            ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
          },
        })
        .then(res => res.text())
        .then((result) => {
          // console.log(result, 'result')
          const json = xmlToJSON.parseString(result)
          const data = json.itemList
          // console.log(data, 'data')
           setPreciseFilm([data?.movies?.movie])
           setFilmSearch(data?.movies?.movie)
        })
      }
      
  }, [orgSelect, key, q,searchPrecise]);
// console.log(data, 'dta')
// console.log(preciseFilm, 'precise film')
// movie click function
function handleMovieClick (film) {
  setFilmbiochanged(false)
  setSelectedFilmId(0)
  setMovieClicked(true)
  setSelectedMovieData(film)
  // console.log(film, 'clicked film')
  setClkdMovieName(film.name)
  setClkdMoviePoster(film.largePath)
  setShowFilms(false)
}

// console.log(selectedMovieData, 'movie data')

// if data.addings has addings but its not array then change data.addings to array
if(selectedMovieData.addings?.length) {
  // console.log('ADDINGS IS ARRAY')
}
else { 
  // console.log('addings is OBJECT')
  let adding = selectedMovieData.addings?.adding
  // console.log(selectedMovieData.addings?.adding, 'adding')
 adding ?  selectedMovieData.addings=[{adding}] : selectedMovieData.addings=[]
} 

const lists = [
  {id:0,title:'GRUNDDATA'},
  {id:1,title:'SYNOPSIS'},
  {id:2,title:'PLAKATER'},
  {id:3,title:'BANNERE'},
  {id:4,title:'TRAILER'},

]
const handleColor = (row) => {
 

  // if(titleChanged === true ) {
  //   setShowGrunddataModal(true)
  // }
  // else  
  setShowFilms(false)
   setSelectedFilmId(row.id);
  setSelectedBtnTitle(row.title)
  setShowBtn(false);
};

//-------------function for checking empty array----------
function isEmpty(obj) {
  for (const prop in obj) {
      if (Object.hasOwn(obj, prop)) {
          return false;
      }
  }
  return true; 
}

function handleFilmChange () {
  // console.log('film change clkd')
  setShowFilms(true)
}

const filmHeight = document.getElementById('imgdiv')?.getBoundingClientRect().height
// let imgdivheight 
const [imgDivH, setImgDivH] = useState();

useEffect(() => { 
 const  imgheight = document.getElementById('imgdiv').getBoundingClientRect().height
 setImgDivH(imgheight)
// console.log(imgheight, 'img div height')
}, [selectedFilmId]);


  return (
    <main className='containers'>
              <Header filmActive='active'/>
        <section className='film-container' id='filmedit'
        style={{height: movieClicked === true && selectedFilmId == 2 ? visualDivHeight+150 : movieClicked === true && selectedFilmId !== 4 && selectedFilmId !== 3 && selectedFilmId !== 2  ? '1480px' : '1130px'}}
        >
            <div style={{paddingLeft:'80px',paddingTop:'57px',backgroundColor:movieClicked === true ? '#ececec' : '',width:movieClicked === true ? '260px' : ''}}>
            
            </div>
            {/* <div> */}
            {movieClicked === false ? 
              <div style={{position:'absolute',top:'57px',left:'80px',}}>
                 <p className='choose_film'>Film</p>
                 <br />
                 <div>
                   
                     <FilmOrgs setQ={setQ}/>
              </div>
              <p className='film-sub-title' style={{marginTop:'22px',color: theme === 'dark' ? '#fff' : '#46484c',fontWeight:700,fontSize:'18px',}}>Søg film i listen til højre</p>
              </div>
              : 
             
              <section id='film'  className='editFilmContainer' >
                <div style={{display:'flex',height:'230px', justifyContent:'space-between'}}> 
                  <div>
                   <p className='choose_film'>Ret Film</p>
                   <br />
                 
                   <FilmOrgs setQ={setQ} setShowFilms={setShowFilms} setSelectedMovieData={setSelectedMovieData} />
         <br />
                   {/* <p className='film-sub-title' style={{marginTop:'38px'}}>Du har valgt filmen 
                    <span style={{color:'#101010',fontWeight:700,letterSpacing:'0.32px'}}> {clkdMovieName}</span></p> */}
                       <br />
                    <div className="buttons-group" style={{width:'626px'}}>
              {lists.map((list, index) => (
                <button
                  className={`butto `}
                  key={list.id}
                  onClick={() => handleColor(list)}
                  style={{
                    backgroundColor:
                      list.id === selectedFilmId && showBtn === false
                        ? "#982f2f"  :theme === 'dark' ? '#4e5052'
                        : "", padding:'5px 25px',
                    color:
                      list.id === selectedFilmId && showBtn === false ? "#fff"  : theme === 'dark'? 'white' : "#982f2f",
                      border: list.id === selectedFilmId ? '' : ( theme === 'dark' ? '1px solid #6c6c6c' : '1px solid #982f2f' ),
                  }}
                >
                  {list.title}
                </button>
              ))}
            </div>
             <p style={{width:'834px',marginTop:'-6px',
              height:'1px',background: 'linear-gradient(90deg, #982F2F 79%, rgba(152, 47, 47, 0.00) 100%)'
              }}></p>
              </div>

             {filmBioChanged === false && showFilms === false && movieClicked === true ?
             <div style={{width:'108px'}}> 
               <img style={{height:'161px',float:'right'}}  src={`https://ebillet.dk/poster/`+clkdMoviePoster} alt="" /> 
               <div>
                   <p style={{color:'#101010',margin:0, float:'right',fontWeight:400,height:'19px'}}>Valgt Film:</p>
                   <p style={{color:'#101010',margin:0, float:'right',fontWeight:700,height:'19px',width:'108px'}} className='film-poster-title'>{clkdMovieName}</p>
                   <button onClick={handleFilmChange} style={{margin:0, float:'right',color:'#982f2f',textDecoration:'underline'}}>Skift film</button>
                </div>
             </div>
             : ''
             }

</div>
            <div> 
              <br /> 
              <br /> 
             <p style={{color:'#982f2f',fontSize:'18px',fontWeight:700,letterSpacing:'0.36px'}}>  {selectedFilmId == 0 ? 'Grunddata' : selectedFilmId == 1 ? 'Synopsis' : selectedFilmId == 2 ? 'Visuals' : selectedFilmId == 3 ? 'Bannere' : 'Trailer'}</p>
             </div>
             {selectedFilmId == 0 ? <GrundData data={selectedMovieData} 
                   distibutors={distibutors} bKDMovies={bkdMovies}/> 
             : selectedFilmId == 1 ? <Synopsis arrTypes={arrtypes} 
                   filmdata={selectedMovieData}/> 
             : selectedFilmId == 2 ? <Visuals data={selectedMovieData}/> 
             : selectedFilmId == 3 ? <Banners data={selectedMovieData}/>
             : selectedFilmId == 4 ? <Trailer data={selectedMovieData}/>
             : ''}
                {/* <GrundData /> */}

              </section>
              }
            {showFilms === false ? 
            <aside className='programContainer_aside' style={{}}>
                 <p className='choose' >Vælg</p>
                 <p className='film'>film</p>
                 
                 <div className='vector'></div>
                 <div className='doubleArrows' style={{marginTop:'30vh'}} onClick={handleShowFilm}>
                    <img src={doublearrow} alt="" />
                 </div>
               
               </aside> 
               : ''}
                 <div id='t'  style={{width:'400px',display: showFilms ? 'grid' : 'none', gridTemplateColumns: showFilms ? '1fr 1fr' : '',marginTop:'1px', top:0,height:'100%'}} className='chooseFilmContainer' >
            <aside className='programContainer_aside' >
                 
               <div className='vector'></div>
               <div  style={{marginTop:'42vh', transform:'rotate(180deg)',marginRight:'20px'}} onClick={handleShowFilm}>

                    <img src={doublearrow} alt="" />
                 
               </div>
               
            </aside>
                <div style={{ width:'338px',paddingLeft:'30px',border:'1px ',display:'grid',gridTemplateRows:'.1fr 1fr'}}>
                  <div>
                  <button style={{float:'right',border:'none', background:'none'}} onClick={handleShowFilm}>
                  <img src={close} alt='close'/> </button>
                  <br />
                  <br />
                  <br />
                <p className='choose_film' >Vælg film</p>
                <p></p>
                {/* <label style={{marginBottom:'10px'}}> Søg præsis <input type='checkbox' checked={searchPrecise} onChange={handlePreciseSearch}/></label> */}
               
                <div style={{position:'relative'}}>
                <input  className='search_film' placeholder='Søg efter film'  value={q}
                            onChange={(e) => setQ(e.target.value)}/> 

                  <span style={{position:'absolute', top:'7px',left:'10px'}}>
                  <img src={searchIcon} alt='search' height='20px'/></span>
              
                </div>

                <label htmlFor="" style={{margin:'20px 0px',display:'flex',position:'relative'}}>
                <input style= {{outline: searchPrecise ? '1px solid grey' : ''}}type='checkbox' checked={searchPrecise} onChange={handlePreciseSearch}/> 
                <span style={{color:'#46484c',position:'absolute',top:'-6px',left:'25px'}}>Slå søgning fra, indtast eksakt titel</span> 
                </label>

               
              
                </div>
                <div id='imgdiv'> 
               { error ? 'kunne ikke vise film, der opstået en fejl' : 
                <div className='image_container' 
                style={{maxHeight:selectedFilmId === 0  || selectedFilmId === 1 ? 1220 : 
                selectedFilmId === 2 && isEmpty(data.liveposter) === false && movieClicked === true ? 1310 : ''}}
                >

                   
                   { 
                     preciseFilm &&  preciseFilm[0] && isEmpty(preciseFilm[0].name) === false ?
                  
                        <div 
                    onClick={() => handleMovieClick( preciseFilm[0])} className='imgCont'  style={{width:'125px'}}
                      >
                     <img   src={ isEmpty(preciseFilm[0]?.largePath) === false ?  `https://ebillet.dk/poster/`+preciseFilm[0]?.largePath : ''}  name={preciseFilm[0]?.name} duration={filmSearch?.length} movieno={preciseFilm[0]?.No} alt={preciseFilm[0]?.name} width='125px' height='185px' />   
                    <span className='tooltiptext'>{preciseFilm[0]?.name}</span>                      
                      </div>      
                 
                     :
                   filmSearch?.length > 0 &&  search(data).map((movie,i) => (
                     
                     <div onClick={() => handleMovieClick(movie)} className='imgCont'  style={{width:'125px'}} >
                    <img   src={ isEmpty(movie.largePath) === false ?  `https://ebillet.dk/poster/`+movie.largePath : ''} id={i} name={movie.name} duration={movie.length} movieno={movie.No} alt={movie.name} width='125px' height='185px' />  
                    <span className='tooltiptext'>{movie.name}</span>                      
                    </div>
                    ))

                  
                  }
                  
                </div> 
     }
     </div>
            </div>
          </div>
          {/* </div> */}
        {movieClicked === true ?   <div className='bottom-container'>
           <p className='saveDataBtn'>gem</p>
          </div> : ''}
      </section>
   </main>
  )
}

export default Film